import { render, staticRenderFns } from "./Armyintroduce.vue?vue&type=template&id=062f2fec&scoped=true&"
import script from "./Armyintroduce.vue?vue&type=script&lang=js&"
export * from "./Armyintroduce.vue?vue&type=script&lang=js&"
import style0 from "./Armyintroduce.vue?vue&type=style&index=0&id=062f2fec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062f2fec",
  null
  
)

export default component.exports